(function () {
  'use strict';

  function shouldAutoplay(video) {
    return video.dataset.lazyAutoplay !== 'false';
  }

  function markReady(video) {
    video.classList.add('lazy-video--ready');
    var wrap = video.closest('[data-lazy-video-wrap]');
    if (wrap) {
      wrap.classList.add('lazy-video-wrap--ready');
    }
    document.dispatchEvent(new CustomEvent('lazy-video:ready', { detail: { video: video } }));
  }

  function playVideo(video) {
    if (!shouldAutoplay(video)) return;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {});
    }
  }

  function activateVideo(video) {
    if (!video || video.tagName !== 'VIDEO') return;

    if (video.dataset.lazyVideoActivated === 'true') {
      playVideo(video);
      return;
    }

    video.dataset.lazyVideoActivated = 'true';
    video.classList.add('lazy-video--loading');

    if (video.getAttribute('preload') === 'none' || video.preload === 'none') {
      video.preload = 'auto';
    }

    video.load();

    var onReady = function () {
      video.classList.remove('lazy-video--loading');
      markReady(video);
      playVideo(video);
    };

    if (video.readyState >= 2) {
      onReady();
    } else {
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
    }
  }

  function schedulePriorityActivation(video) {
    function run() {
      activateVideo(video);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
  }

  function init() {
    var videos = document.querySelectorAll('video.js-lazy-video');
    if (!videos.length) return;

    var deferred = [];

    videos.forEach(function (video) {
      if (video.closest('smart-automation-media')) return;

      if (
        video.classList.contains('js-lazy-video--hero') ||
        video.classList.contains('js-lazy-video--priority')
      ) {
        schedulePriorityActivation(video);
      } else {
        deferred.push(video);
      }
    });

    if (!deferred.length) return;

    if (!('IntersectionObserver' in window)) {
      deferred.forEach(schedulePriorityActivation);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activateVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '300px 0px', threshold: 0.01 }
    );

    deferred.forEach(function (video) {
      observer.observe(video);
    });
  }

  window.TechnixiaLazyVideo = {
    activate: activateVideo,
    play: playVideo
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
